// English source strings of the micro-system flow (decision D28, docs/delivery/microsystem-plan.md): the project launch
// card on the Kanban (repository → planning → start agents → publish to Coolify) and the project's agent runs table.
// Merged into `en`; pt-BR lives in pt-BR-microsystem.ts (complete, checked by the type).
export const enMicrosystem = {
  "launch.title": "Launch",
  "launch.opensInNewTab": "(opens in a new tab)",
  "launch.repository": "Repository",
  "launch.queued": "Queued",
  "launch.ready": "Ready",
  "launch.failed": "Failed",
  "launch.planning": "Planning",
  "launch.planningNone": "Not planned yet",
  "launch.agents": "Agents",
  "launch.agentsNotStarted": "Not started",
  "launch.agentsRunning": "Working",
  "launch.agentsWaiting": "Waiting for resources",
  "launch.executionEnabled": "Project execution enabled. Agent activity appears once an attempt starts.",
  "launch.agentsPaused": "Paused",
  "launch.agentsDone": "All tasks done",
  "launch.startAgents": "Start agents",
  "launch.startHint": "The agents build the planned tasks in parallel; each one is tested and merged into main.",
  "launch.startWaitsRepository": "Available once the repository is cloned.",
  "launch.startWaitsPlanning": "Available once planning has finished.",
  "launch.startNeedsRole": "Starting the agents needs the maintainer role on this project.",
  "launch.agentsStarted": "Agents started.",
  "launch.publish": "Publish",
  "launch.publishButton": "Publish to Coolify",
  "launch.republish": "Publish again",
  "launch.publishRequested": "Publishing started.",
  "launch.publishBeforeDone": "Not every task is done yet: publishing now deploys what is on main today.",
  "launch.publishNeedsAdmin": "An organization admin publishes the app.",
  "launch.publishNone": "Not published",
  "launch.publishProgress": "Publishing steps",
  "launch.publishFailed": "Publishing failed.",
  "launch.publishFinished": "Finished {when}.",
  "launch.openApp": "Open the app",
  "launch.publishState.queued": "Queued",
  "launch.publishState.creating_repository": "Creating the GitHub repository",
  "launch.publishState.pushing": "Pushing to GitHub",
  "launch.publishState.creating_app": "Creating the app",
  "launch.publishState.deploying": "Deploying",
  "launch.publishState.succeeded": "Live",
  "launch.publishState.failed": "Failed",

  // D31: the project's publication in the header and on the preview surfaces.
  "publication.notPublished": "Not published",
  "publication.publishing": "Publishing… ({state})",
  "publication.live": "Live",
  "publication.failed": "Publish failed",
  "publication.failedCode": "Publish failed ({code})",
  "publication.openApp": "Open app",
  "publication.publish": "Publish",
  "publication.previewHint": "Publish the project to get a live URL",
  "publication.connectGithub": "Connect GitHub",
  "publication.emptyTitle": "Not published yet",
  "publication.emptyBody": "This project has no preview yet. Publish it to Coolify to get a live URL; the published app becomes the project's preview.",
  "publication.liveTitle": "Published app",
  "publication.liveBody": "The project is live at this URL. It opens in a new tab.",
  "publication.policy": "Published app: its framing was never checked, so it opens in a new tab instead of being embedded here.",

  "agentRuns.title": "Agent runs",
  "agentRuns.hint": "Every agent run of this project. Consults and delegations are listed under the run that asked for them.",
  "agentRuns.outcomeFilter": "Status",
  "agentRuns.emptyTitle": "No agent runs yet",
  "agentRuns.emptyBody": "Runs appear here once the agents start working on this project's tasks.",
  "agentRuns.agent": "Agent",
  "agentRuns.purposeColumn": "Purpose",
  "agentRuns.parent": "Parent run",
  "agentRuns.status": "Status",
  "agentRuns.steps": "Steps",
  "agentRuns.modelCalls": "Model calls",
  "agentRuns.toolCalls": "Tool calls",
  "agentRuns.tokens": "Tokens",
  "agentRuns.tokensDetail": "{input} in, {output} out",
  "agentRuns.cost": "Cost",
  "agentRuns.unknownCost": "unknown",
  "agentRuns.started": "Started",
  "agentRuns.finished": "Finished",
  "agentRuns.notFinished": "still running",
  "agentRuns.limited": "Showing the latest {n} runs.",
  "agentRuns.purpose.build": "Run",
  "agentRuns.purpose.consult": "Consult",
  "agentRuns.purpose.delegate": "Delegate",
  "agentRuns.purpose.review": "Review",
  "agentRuns.purpose.reflect": "Reflect",
  "agentRuns.purpose.assistant": "Assistant",
  "agentRuns.outcome.running": "Running",
  "agentRuns.outcome.succeeded": "Succeeded",
  "agentRuns.outcome.failed": "Failed",
  "agentRuns.outcome.interrupted": "Interrupted",
  "agentRuns.outcome.blocked": "Blocked",
  "agentRuns.outcome.cancelled": "Cancelled",
} as const;
